export default __webpack_public_path__ + "static/media/github.a5ed9910.png";